// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: block;
  width: 100%;
  contain: layout;
  will-change: transform;
}

.prompt-box {
  margin: 0 auto;
  display: flex;
  flex-grow: 1;
  padding: 0 0.75rem;
  position: relative;
}
@media (min-width: 1200px) {
  .prompt-box {
    max-width: 48rem;
    padding: 0 1.25rem;
  }
}
@media (min-width: 992px) {
  .prompt-box {
    max-width: 40rem;
    padding: 0 0.25rem;
  }
}
@media (min-width: 768px) {
  .prompt-box {
    max-width: 48rem;
    padding: 0 1rem;
  }
}

.form-field {
  width: 100%;
}
.form-field.agents-loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Loading indicator when connecting to agent */
.agents-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 10;
  background: var(--chat-area-bg, var(--surface-color, rgba(255, 255, 255, 0.9)));
  padding: 8px 16px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.agents-loading span {
  font-size: 13px;
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  white-space: nowrap;
}

.input-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  margin-right: 8px;
}
.input-actions .mobile-ambient-mic {
  display: none;
}
.input-actions .mobile-ambient-mic {
  cursor: pointer;
}
.input-actions .mobile-ambient-mic.recording {
  opacity: 1 !important;
  background-color: #f44336;
  color: white;
  animation: pulse-recording 1.5s ease-in-out infinite;
}
.input-actions .upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}
.input-actions .upload-btn.mobile-upload {
  display: none;
}
.input-actions .upload-btn:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.08);
}
.input-actions .upload-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.input-actions .voice-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}
.input-actions .voice-btn:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.08);
}
.input-actions .voice-btn.recording {
  opacity: 1;
  background-color: #f44336;
  color: white;
  animation: pulse-recording 1.5s ease-in-out infinite;
}
.input-actions .voice-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.input-actions .safe-mode-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.4;
  transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}
.input-actions .safe-mode-btn:hover {
  opacity: 0.8;
  background-color: rgba(0, 0, 0, 0.08);
}
.input-actions .safe-mode-btn.active {
  opacity: 1;
  background-color: #e53935;
  color: white;
  animation: pulse-safe-mode 2s ease-in-out infinite;
}
.input-actions .safe-mode-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

@keyframes pulse-recording {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(244, 67, 54, 0);
  }
}
@keyframes pulse-safe-mode {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.3);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(229, 57, 53, 0);
  }
}
.drop-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 2px dashed var(--primary-color, #7aa2f7);
  border-radius: 8px;
  background: rgba(122, 162, 247, 0.08);
  color: var(--primary-color, #7aa2f7);
  font-size: 14px;
  pointer-events: none;
}
.drop-overlay mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  opacity: 0.8;
}

.pending-files-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  flex-wrap: wrap;
}

.pending-file-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  background: var(--surface-color, rgba(0, 0, 0, 0.06));
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
  font-size: 12px;
  max-width: 220px;
}
.pending-file-chip .file-chip-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.6;
  flex-shrink: 0;
}
.pending-file-chip .file-chip-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}
.pending-file-chip .file-chip-size {
  font-size: 10px;
  opacity: 0.5;
  flex-shrink: 0;
}
.pending-file-chip .file-chip-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.5;
  padding: 0;
  flex-shrink: 0;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}
.pending-file-chip .file-chip-remove:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.1);
}
.pending-file-chip .file-chip-remove mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.pending-images-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
  padding: 8px 16px;
  flex-wrap: wrap;
}

.pending-image-preview {
  position: relative;
  display: inline-flex;
}
.pending-image-preview img {
  max-height: 120px;
  max-width: 160px;
  border-radius: 8px;
  object-fit: contain;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.pending-image-preview .remove-image-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease;
}
.pending-image-preview .remove-image-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}
.pending-image-preview .remove-image-btn mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

textarea {
  max-height: 200px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb, rgba(128, 128, 128, 0.4)) transparent;
}
textarea::-webkit-scrollbar {
  width: 6px;
}
textarea::-webkit-scrollbar-track {
  background: transparent;
}
textarea::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb, rgba(128, 128, 128, 0.4));
  border-radius: 3px;
}
textarea::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover, rgba(128, 128, 128, 0.6));
}

/* Mobile placeholder for voice/type guidance */
.mobile-placeholder {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--text-secondary, rgba(128, 128, 128, 0.8));
  font-size: 16px;
  z-index: 1;
  transition: opacity 0.15s ease;
}
.mobile-placeholder.recording {
  color: rgba(255, 255, 255, 0.9);
}

/* Recording state - red background */
.form-field.recording ::ng-deep .mdc-text-field--filled {
  background-color: #f44336 !important;
}
.form-field.recording textarea {
  color: white !important;
}
.form-field.recording textarea::placeholder {
  color: rgba(255, 255, 255, 0.8) !important;
}

/* Hand-raised state — throbbing yellow when interrupt is pending */
.hand-raised .mat-icon {
  color: #ffc107 !important;
  animation: hand-throb 0.8s ease-in-out infinite;
}

@keyframes hand-throb {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.15);
  }
}
/* Mobile-specific adjustments */
@media (max-width: 768px) {
  .prompt-box {
    padding: 0 !important;
    max-width: 100% !important;
    width: 100%;
    margin: 0;
  }
  .input-actions {
    margin-left: 4px;
    margin-right: 4px;
    gap: 4px;
  }
  .input-actions .desktop-upload {
    display: none !important;
  }
  .input-actions .mobile-upload,
  .input-actions .mobile-ambient-mic {
    display: flex !important;
  }
  .input-actions .upload-btn,
  .input-actions .voice-btn,
  .input-actions .safe-mode-btn {
    width: 40px;
    height: 40px;
  }
  .input-actions .upload-btn mat-icon,
  .input-actions .voice-btn mat-icon,
  .input-actions .safe-mode-btn mat-icon {
    font-size: 22px;
    width: 22px;
    height: 22px;
  }
  .form-field {
    width: 100%;
    overflow: visible !important;
    position: relative;
  }
  .form-field ::ng-deep .mdc-text-field--filled,
  .form-field ::ng-deep .mat-mdc-text-field-wrapper {
    border-radius: 0 !important;
    padding-left: 0 !important;
    padding-right: 48px !important;
    overflow: visible !important;
  }
  .form-field ::ng-deep .mat-mdc-form-field-icon-suffix {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
  }
  .form-field ::ng-deep .mat-mdc-form-field-infix {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    min-height: unset !important;
  }
  .form-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
    display: none !important;
  }
  textarea {
    min-height: 60px !important;
    max-height: 120px !important;
    overflow-y: auto !important;
  }
  textarea::placeholder {
    color: transparent !important;
    opacity: 0 !important;
  }
  .input-actions {
    align-self: center;
  }
}
@media (max-width: 480px) {
  .input-actions {
    margin-left: 2px;
    margin-right: 2px;
  }
  .input-actions .upload-btn,
  .input-actions .voice-btn,
  .input-actions .safe-mode-btn {
    width: 40px;
    height: 40px;
  }
  .input-actions .upload-btn mat-icon,
  .input-actions .voice-btn mat-icon,
  .input-actions .safe-mode-btn mat-icon {
    font-size: 22px;
    width: 22px;
    height: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/chat-input/chat-input.component.scss","webpack://./src/styles/_breakpoints.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,cAAA;EACA,WAAA;EAGA,eAAA;EAEA,sBAAA;AAHF;;AAMA;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAHF;ACFI;EDAJ;IAQI,gBAAA;IACA,kBAAA;EAFF;AACF;ACRI;EDAJ;IAaI,gBAAA;IACA,kBAAA;EADF;AACF;ACdI;EDAJ;IAkBI,gBAAA;IACA,eAAA;EAAF;AACF;;AAGA;EACE,WAAA;AAAF;AAEE;EACE,YAAA;EACA,oBAAA;AAAJ;;AAIA,+CAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,+EAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;AADF;AAGE;EACE,eAAA;EACA,gDAAA;EACA,mBAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;AAFF;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;AAKI;EACE,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,oDAAA;AAHN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAKA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,2DAAA;AATJ;AACI;EACE,aAAA;AACN;AAQI;EACE,UAAA;EACA,qCAAA;AANN;AASI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAPN;AAWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,6EAAA;AATJ;AAWI;EACE,UAAA;EACA,qCAAA;AATN;AAYI;EACE,UAAA;EACA,yBAAA;EACA,YAAA;EACA,oDAAA;AAVN;AAaI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAXN;AAeE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,6EAAA;AAbJ;AAeI;EACE,YAAA;EACA,qCAAA;AAbN;AAgBI;EACE,UAAA;EACA,yBAAA;EACA,YAAA;EACA,kDAAA;AAdN;AAiBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAfN;;AAoBA;EACE;IACE,0CAAA;EAjBF;EAmBA;IACE,0CAAA;EAjBF;AACF;AAoBA;EACE;IACE,0CAAA;EAlBF;EAoBA;IACE,0CAAA;EAlBF;AACF;AAsBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gDAAA;EACA,kBAAA;EACA,qCAAA;EACA,oCAAA;EACA,eAAA;EACA,oBAAA;AApBF;AAsBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AApBJ;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,qDAAA;EACA,yDAAA;EACA,eAAA;EACA,gBAAA;AAtBF;AAwBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAtBJ;AAyBE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;AAvBJ;AA0BE;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,2DAAA;AAzBJ;AA2BI;EACE,UAAA;EACA,8BAAA;AAzBN;AA4BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1BN;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,oBAAA;AA5BF;AA8BE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AA5BJ;AA+BE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;AA7BJ;AA+BI;EACE,8BAAA;AA7BN;AAgCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9BN;;AAmCA;EACE,iBAAA;EACA,gBAAA;EAqBA,qBAAA;EACA,6EAAA;AApDF;AAiCE;EACE,UAAA;AA/BJ;AAkCE;EACE,uBAAA;AAhCJ;AAmCE;EACE,kEAAA;EACA,kBAAA;AAjCJ;AAmCI;EACE,wEAAA;AAjCN;;AA0CA,+CAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,sDAAA;EACA,eAAA;EACA,UAAA;EACA,8BAAA;AAvCF;AAyCE;EACE,+BAAA;AAvCJ;;AA2CA,qCAAA;AAEE;EACE,oCAAA;AAzCJ;AA4CE;EACE,uBAAA;AA1CJ;AA4CI;EACE,0CAAA;AA1CN;;AA+CA,mEAAA;AAEE;EACE,yBAAA;EACA,+CAAA;AA7CJ;;AAiDA;EACE;IAAW,UAAA;IAAY,mBAAA;EA5CvB;EA6CA;IAAM,YAAA;IAAc,sBAAA;EAzCpB;AACF;AA2CA,gCAAA;AACA;EACE;IACE,qBAAA;IACA,0BAAA;IACA,WAAA;IACA,SAAA;EAzCF;EA4CA;IACE,gBAAA;IACA,iBAAA;IACA,QAAA;EA1CF;EA4CE;IACE,wBAAA;EA1CJ;EA6CE;;IAEE,wBAAA;EA3CJ;EA8CE;;;IAGE,WAAA;IACA,YAAA;EA5CJ;EA8CI;;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA1CN;EA+CA;IACE,WAAA;IACA,4BAAA;IACA,kBAAA;EA7CF;EA+CE;;IAEE,2BAAA;IACA,0BAAA;IACA,8BAAA;IACA,4BAAA;EA7CJ;EAgDE;IACE,kBAAA;IACA,UAAA;IACA,QAAA;IACA,2BAAA;EA9CJ;EAiDE;IACE,2BAAA;IACA,8BAAA;IACA,4BAAA;EA/CJ;EAkDE;IACE,wBAAA;EAhDJ;EAoDA;IACE,2BAAA;IACA,4BAAA;IACA,2BAAA;EAlDF;EAoDE;IACE,6BAAA;IACA,qBAAA;EAlDJ;EAsDA;IACE,kBAAA;EApDF;AACF;AAuDA;EACE;IACE,gBAAA;IACA,iBAAA;EArDF;EAuDE;;;IAGE,WAAA;IACA,YAAA;EArDJ;EAuDI;;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAnDN;AACF","sourcesContent":["@import '../../../styles/breakpoints';\n\n:host {\n  display: block;\n  width: 100%;\n  // Isolate layout changes in the input area from affecting parent scroll containers\n  // This prevents textarea resize from triggering scroll position changes in ancestors\n  contain: layout;\n  // Create a separate compositing layer to isolate repaints/reflows\n  will-change: transform;\n}\n\n.prompt-box {\n  margin: 0 auto;\n  display: flex;\n  flex-grow: 1;\n  padding: 0 0.75rem;\n  position: relative;\n\n  @include respond-to(xl) {\n    max-width: 48rem;\n    padding: 0 1.25rem;\n  }\n\n  @include respond-to(lg) {\n    max-width: 40rem;\n    padding: 0 0.25rem;\n  }\n\n  @include respond-to(md) {\n    max-width: 48rem;\n    padding: 0 1rem;\n  }\n}\n\n.form-field {\n  width: 100%;\n\n  &.agents-loading {\n    opacity: 0.6;\n    pointer-events: none;\n  }\n}\n\n/* Loading indicator when connecting to agent */\n.agents-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  z-index: 10;\n  background: var(--chat-area-bg, var(--surface-color, rgba(255, 255, 255, 0.9)));\n  padding: 8px 16px;\n  border-radius: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n\n  span {\n    font-size: 13px;\n    color: var(--text-secondary, rgba(0, 0, 0, 0.6));\n    white-space: nowrap;\n  }\n}\n\n.input-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 8px;\n  margin-right: 8px;\n\n  .mobile-ambient-mic {\n    display: none;\n  }\n\n  .mobile-ambient-mic {\n    cursor: pointer;\n\n    &.recording {\n      opacity: 1 !important;\n      background-color: #f44336;\n      color: white;\n      animation: pulse-recording 1.5s ease-in-out infinite;\n    }\n  }\n\n  .upload-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &.mobile-upload {\n      display: none;\n    }\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    cursor: pointer;\n    opacity: 0.6;\n    transition: opacity 0.15s ease, background-color 0.15s ease;\n\n    &:hover {\n      opacity: 1;\n      background-color: rgba(0, 0, 0, 0.08);\n    }\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .voice-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    opacity: 0.6;\n    transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n    &:hover {\n      opacity: 1;\n      background-color: rgba(0, 0, 0, 0.08);\n    }\n\n    &.recording {\n      opacity: 1;\n      background-color: #f44336;\n      color: white;\n      animation: pulse-recording 1.5s ease-in-out infinite;\n    }\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .safe-mode-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    opacity: 0.4;\n    transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n    &:hover {\n      opacity: 0.8;\n      background-color: rgba(0, 0, 0, 0.08);\n    }\n\n    &.active {\n      opacity: 1;\n      background-color: #e53935;\n      color: white;\n      animation: pulse-safe-mode 2s ease-in-out infinite;\n    }\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n@keyframes pulse-recording {\n  0%, 100% {\n    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 0 8px rgba(244, 67, 54, 0);\n  }\n}\n\n@keyframes pulse-safe-mode {\n  0%, 100% {\n    box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.3);\n  }\n  50% {\n    box-shadow: 0 0 0 6px rgba(229, 57, 53, 0);\n  }\n}\n\n// Drop zone overlay\n.drop-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 2px dashed var(--primary-color, #7aa2f7);\n  border-radius: 8px;\n  background: rgba(122, 162, 247, 0.08);\n  color: var(--primary-color, #7aa2f7);\n  font-size: 14px;\n  pointer-events: none;\n\n  mat-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n    opacity: 0.8;\n  }\n}\n\n// Pending file chips\n.pending-files-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 16px;\n  flex-wrap: wrap;\n}\n\n.pending-file-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  background: var(--surface-color, rgba(0, 0, 0, 0.06));\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));\n  font-size: 12px;\n  max-width: 220px;\n\n  .file-chip-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0.6;\n    flex-shrink: 0;\n  }\n\n  .file-chip-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .file-chip-size {\n    font-size: 10px;\n    opacity: 0.5;\n    flex-shrink: 0;\n  }\n\n  .file-chip-remove {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    opacity: 0.5;\n    padding: 0;\n    flex-shrink: 0;\n    transition: opacity 0.15s ease, background-color 0.15s ease;\n\n    &:hover {\n      opacity: 1;\n      background: rgba(0, 0, 0, 0.1);\n    }\n\n    mat-icon {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n    }\n  }\n}\n\n.pending-images-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 8px 16px;\n  flex-wrap: wrap;\n}\n\n.pending-image-preview {\n  position: relative;\n  display: inline-flex;\n\n  img {\n    max-height: 120px;\n    max-width: 160px;\n    border-radius: 8px;\n    object-fit: contain;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  .remove-image-btn {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    border: none;\n    background: rgba(0, 0, 0, 0.6);\n    color: white;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.15s ease;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.8);\n    }\n\n    mat-icon {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n    }\n  }\n}\n\ntextarea {\n  max-height: 200px;\n  overflow-y: auto;\n\n  // Scrollbar styling\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--scrollbar-thumb, rgba(128, 128, 128, 0.4));\n    border-radius: 3px;\n\n    &:hover {\n      background-color: var(--scrollbar-thumb-hover, rgba(128, 128, 128, 0.6));\n    }\n  }\n\n  // Firefox\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb, rgba(128, 128, 128, 0.4)) transparent;\n}\n\n/* Mobile placeholder for voice/type guidance */\n.mobile-placeholder {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--text-secondary, rgba(128, 128, 128, 0.8));\n  font-size: 16px;\n  z-index: 1;\n  transition: opacity 0.15s ease;\n\n  &.recording {\n    color: rgba(255, 255, 255, 0.9);\n  }\n}\n\n/* Recording state - red background */\n.form-field.recording {\n  ::ng-deep .mdc-text-field--filled {\n    background-color: #f44336 !important;\n  }\n\n  textarea {\n    color: white !important;\n\n    &::placeholder {\n      color: rgba(255, 255, 255, 0.8) !important;\n    }\n  }\n}\n\n/* Hand-raised state — throbbing yellow when interrupt is pending */\n.hand-raised {\n  .mat-icon {\n    color: #ffc107 !important;\n    animation: hand-throb 0.8s ease-in-out infinite;\n  }\n}\n\n@keyframes hand-throb {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.5; transform: scale(1.15); }\n}\n\n/* Mobile-specific adjustments */\n@media (max-width: 768px) {\n  .prompt-box {\n    padding: 0 !important;\n    max-width: 100% !important;\n    width: 100%;\n    margin: 0;\n  }\n\n  .input-actions {\n    margin-left: 4px;\n    margin-right: 4px;\n    gap: 4px;\n\n    .desktop-upload {\n      display: none !important;\n    }\n\n    .mobile-upload,\n    .mobile-ambient-mic {\n      display: flex !important;\n    }\n\n    .upload-btn,\n    .voice-btn,\n    .safe-mode-btn {\n      width: 40px;\n      height: 40px;\n\n      mat-icon {\n        font-size: 22px;\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n\n  .form-field {\n    width: 100%;\n    overflow: visible !important;\n    position: relative;\n\n    ::ng-deep .mdc-text-field--filled,\n    ::ng-deep .mat-mdc-text-field-wrapper {\n      border-radius: 0 !important;\n      padding-left: 0 !important;\n      padding-right: 48px !important;\n      overflow: visible !important;\n    }\n\n    ::ng-deep .mat-mdc-form-field-icon-suffix {\n      position: absolute;\n      right: 4px;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n\n    ::ng-deep .mat-mdc-form-field-infix {\n      padding-top: 8px !important;\n      padding-bottom: 8px !important;\n      min-height: unset !important;\n    }\n\n    ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n      display: none !important;\n    }\n  }\n\n  textarea {\n    min-height: 60px !important;\n    max-height: 120px !important;\n    overflow-y: auto !important;\n\n    &::placeholder {\n      color: transparent !important;\n      opacity: 0 !important;\n    }\n  }\n\n  .input-actions {\n    align-self: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .input-actions {\n    margin-left: 2px;\n    margin-right: 2px;\n\n    .upload-btn,\n    .voice-btn,\n    .safe-mode-btn {\n      width: 40px;\n      height: 40px;\n\n      mat-icon {\n        font-size: 22px;\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n}\n","$breakpoints: (\n  'xs': 0px,\n  'sm': 576px,\n  'md': 768px,\n  'lg': 992px,\n  'xl': 1200px,\n  'xxl': 1400px,\n  'xxxl': 2100px\n) !default;\n\n@mixin respond-to($breakpoint) {\n  @if map-has-key($breakpoints, $breakpoint) {\n    @media (min-width: map-get($breakpoints, $breakpoint)) {\n      @content;\n    }\n  } @else {\n    @warn \"Unfortunately, no value could be retrieved from `#{$breakpoint}`. Available breakpoints are: #{map-keys($breakpoints)}.\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
